<template>
  <div>
    <div v-if="editLoading || createLandLoading || parseLoading">
      <div class="loading-enc-edit">
        <svg class="loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340">
          <circle cx="170" cy="170" r="160" stroke="#4E53E7"/>
          <circle cx="170" cy="170" r="135" stroke="#404041"/>
          <circle cx="170" cy="170" r="110" stroke="#4E53E7"/>
          <circle cx="170" cy="170" r="85" stroke="#404041"/>
        </svg>
        <div class="loading-text" v-if="createLandLoading">
          {{ createLandLoadingText }}
        </div>
      </div>
    </div>
    <div v-show="!editLoading && !createLandLoading && !parseLoading">
      <div class="popup-create-wrapper">
        <div class="popup-menu">
          <ul>
            <li @click="activeTab = 'general'" :class="{'active': activeTab === 'general', 'no-valid': !isValid}">Общие сведения</li>
            <li @click="activeTab = 'characteristic'" :class="{'active': activeTab === 'characteristic'}">Сведения о характеристиках ЗУ</li>
            <li @click="activeTab = 'owner'" :class="{'active': activeTab === 'owner'}">Сведения о правообладателях и арендаторах ЗУ</li>
            <li @click="activeTab = 'map'" :class="{'active': activeTab === 'map'}">Карта</li>
            <li @click="activeTab = 'view'" :class="{'active': activeTab === 'view'}">Просмотр</li>
            <li @click="deleteAskDialogShow = true" v-if="mode === 'edit' && permisCreate" class="delete">Удалить участок</li>
          </ul>
        </div>
        <div class="popup-create">
          <div class="popup-header">
            <h4 class="title">{{ mode === 'edit' ? 'Редактирование участка' : 'Создание участка'}}</h4>
            <!-- <button @click="qwe()">dsf</button> -->
          </div>
          <!-- <transition name="popup-show"> -->
            <div class="step step-1" v-show="activeTab === 'general'">
              <p class="subtitle">1. Общие сведения</p>
              <vue-custom-scrollbar class="scroll-info">
                <div class="create-content">
                  <!--  -->
                  <div class="input-wrap">
                    <p>Кадастровый номер <span>*</span></p>
                    <p><span v-if="!isValid">Участок с таким кадастровым номером уже существует!</span></p>
                    <input class="reg-number form-control" type="text" v-model.lazy="newObject.regNum">
                  </div>
                  <!--  -->
                  <div class="input-wrap">
                    <p>Площадь по документам <span>*</span></p>
                    <div class="area">
                      <div class="half">
                        <input class="form-control" v-model="newObject.areaBydoc" @input="inputAreaMeter($event, 'bydoc')" type="number">
                        <span>м<sup>2</sup></span>
                      </div>
                      <div class="half">
                        <input class="form-control" v-model="areaHectare" @input="inputAreaHectare($event, 'bydoc')" type="number">
                        <span>Га</span>
                      </div>
                    </div>
                  </div>
                  <!--  -->
                  <!-- <div class="input-wrap">
                    <p>Площадь фактическая</p>
                    <div class="area">
                      <div class="half">
                        <input class="form-control" v-model="newObject.areaBygeom" @input="inputAreaMeter($event, 'bygeom')" type="number">
                        <span>м<sup>2</sup></span>
                      </div>
                      <div class="half">
                        <input class="form-control" v-model="areaHectareGeom" @input="inputAreaHectare($event, 'bygeom')" type="number">
                        <span>Га</span>
                      </div>
                    </div>
                  </div> -->
                  <!--  -->
                  <div class="input-wrap">
                    <p>Кадастровая стоимость</p>
                    <input class="form-control" v-model="newObject.cadCost" type="number">
                  </div>
                  <!--  -->
                  <div class="input-wrap">
                    <p>Тип участка</p>
                    <v-select
                      v-model="newObject.typeZuCode"
                      :reduce="typeZu => typeZu.code"
                      :options="typeZuListOptions"
                      placeholder="Выберите тип участка"
                    >
                      <span slot="no-options">Не найдено совпадений</span>
                    </v-select>
                  </div>
                  <!--  -->
                  <div class="input-wrap">
                    <p>Разрешенное использование</p>
                    <input class="form-control" @click="setShowPopup('landUseCode', true)" :value="newObject.landUseText" type="text">
                  </div>
                  <!--  -->
                  <div class="input-wrap">
                    <p> Разрешенное использование по н.клсф.</p>
                    <input class="form-control" @click="setShowPopup('landUseMerCode', true)" :value="newObject.landUseMerText" type="text">
                  </div>
                  <!--  -->
                  <div class="input-wrap">
                    <p>Разрешенное использование по документам</p>
                    <input class="form-control" v-model="newObject.landUseBydoc" type="text">
                  </div>
                  <!--  -->
                  <div class="input-wrap">
                    <p>Наименование колхоза</p>
                    <input class="form-control" v-model="newObject.location.kolhoz" type="text">
                  </div>
                  <!--  -->
                  <div class="input-wrap">
                    <p>Адрес</p>
                    <input v-model="newObject.location.text" class="form-control" type="text">
                  </div>
                  <!--  -->
                  <div class="input-wrap">
                    <p>Описание</p>
                    <textarea class="form-control" v-model="newObject.location.note" type="text"></textarea>
                  </div>
                  <!--  -->
                  <div class="input-wrap">
                    <p>Фото</p>
                    <FileLoader :initData="photoInitData" :showImage="true" @changeFileList="setPhoto($event)"/>
                  </div>
                  <div class="input-wrap">
                    <p>Приложение</p>
                    <FileLoader :initData="appendixInitData" @changeFileList="setappendices($event)"/>
                  </div>
                </div>
              </vue-custom-scrollbar>
            </div>
          <!-- </transition> -->
          <!-- <transition name="popup-show"> -->
            <div class="step step-2" v-show="activeTab === 'characteristic'">
              <p class="subtitle">2. Сведения о характеристиках ЗУ</p>
              <vue-custom-scrollbar class="scroll-info">
                <div class="create-content">
                  <div class="input-wrap">
                    <p>Категория земли</p>
                    <v-select
                      v-model="newObject.categoryCode"
                      :reduce="category => category.code"
                      :options="categoryListOptions"
                      placeholder="Выберите"
                    >
                      <span slot="no-options">Не найдено совпадений</span>
                    </v-select>
                  </div>
                  <!-- <div class="input-wrap">
                    <p>Сельское поселение</p> -->
                    <!-- <input class="form-control" @click="setShowPopup('selectOkato', true)" :value="newObject.okatoSp.text" type="text"> -->
                  <!-- </div> -->
                  <div class="input-wrap">
                    <p>Вид угодий</p>
                    <div class="type-land">
                      <div class="type-row">
                        <div class="cell">
                          <span>Вид</span>
                        </div>
                        <div class="cell">
                          <span>Площадь, м<sup>2</sup></span>
                        </div>
                        <div class="cell no-border" style="width: 10px">
                          <span></span>
                        </div>
                      </div>
                      <div class="type-row" v-for="(tlu, index) in newObject.landTlu" :key="index">
                        <div class="cell">
                          <v-select
                            class="table-select"
                            :reduce="tlu => tlu.code"
                            :options="tluListOptions"
                            placeholder="Выберите"
                            v-model="newObject.landTlu[index].tluCode"
                          >
                            <span slot="no-options">Не найдено совпадений</span>
                          </v-select>
                        </div>
                        <div class="cell">
                          <input v-model="newObject.landTlu[index].area" type="number" step="0.01">
                        </div>
                        <div class="cell no-border">
                          <button @click="delItem(index, 'tlu')" class="">
                            <img src="@img/close.svg" alt="">
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button @click="addItem('tlu')" class="btn btn-add">
                    <span>+</span>
                    Добавить вид
                  </button>
                </div>
              </vue-custom-scrollbar>
            </div>
          <!-- </transition> -->
          <!-- <transition name="popup-show"> -->
            <div class="step step-3" v-show="activeTab === 'owner'">
              <p class="subtitle">3. Сведения о правообладателях и арендаторах ЗУ</p>
              <div class="create-content right-content">
                <div class="right-wrap">
                  <div class="pos-r" v-for="(right, index) in newObject.right" :key="'right_' + right.localId">
                    <RightEditVue :rightIndex="index + 1" @changeRight="changeRight($event, index)" :mode="mode" :propsData="right.propsData" />
                    <button @click="delItem(index, 'right')" class="cell no-border">
                      <img src="@img/close.svg" alt="">
                    </button>
                  </div>
                  <button @click="addItem('right')" class="btn btn-add">
                    <span>+</span>
                    Добавить право
                  </button>
                </div>
              </div>
            </div>
          <!-- </transition> -->
          <!-- <transition name="popup-show"> -->
            <div class="step step-4" v-show="activeTab === 'map'">
              <p class="subtitle">4. Карта</p>
              <div class="create-content" style="position: relative">
                <MapCreateEditVue @roundedArea="setRoundedArea" :areaBygeomForMap="newObject.areaBygeom" :initCoords="geometry" :createMap="activeTab === 'map'" :mode="mode" @setCoords="setNewGeometry($event)"/>
              </div>
            </div>
          <!-- </transition> -->
          <!-- <transition name="popup-show"> -->
            <div class="step step-5" v-show="activeTab === 'view'">
              <p class="subtitle">5. Просмотр</p>
              <vue-custom-scrollbar :settings="settings" class="scroll-info">
                <div class="create-content">
                  <h5 class="view-title">Общие сведения</h5>
                  <div class="view-item">
                    <h4>Кадастровый номер</h4>
                    <span>{{ newObject.regNum }}</span>
                  </div>
                  <div class="view-item">
                    <h4>Площадь по документам</h4>
                    <span>{{ newObject.areaBydoc }}</span>
                  </div>
                  <div class="view-item">
                    <h4>Фактическая площадь</h4>
                    <span>{{ newObject.areaBygeom }}</span>
                  </div>
                  <div class="view-item">
                    <h4>Кадастровая стоимость</h4>
                    <span>{{ newObject.cadCost }}</span>
                  </div>
                  <div class="view-item">
                    <h4>Тип участка</h4>
                    <span>{{ typeZuText }}</span>
                  </div>
                  <div class="view-item">
                    <h4>Разрешенное использование</h4>
                    <span>{{ newObject.landUseText }}</span>
                  </div>
                  <div class="view-item">
                    <h4>Разрешенное использование по н.клсф.</h4>
                    <span>{{ newObject.landUseMerText }}</span>
                  </div>
                  <div class="view-item">
                    <h4>Разрешенное использование по документам</h4>
                    <span>{{ newObject.landUseBydoc }}</span>
                  </div>
                  <div class="view-item">
                    <h4>Наименование колхоза</h4>
                    <span>{{ newObject.location.kolhoz }}</span>
                  </div>
                  <div class="view-item">
                    <h4>Адрес</h4>
                    <span>{{ newObject.location.text }}</span>
                  </div>
                  <div class="view-item">
                    <h4>Описание</h4>
                    <span>{{ newObject.location.note }}</span>
                  </div>
                  <h5 class="view-title">Сведения о характеристиках ЗУ</h5>
                  <div class="view-item">
                    <h4>Категория земли</h4>
                    <span>{{ categoryText }}</span>
                  </div>
                  <div class="create-content" v-for="(item, index) in newObject.landTlu" :key="index">
                    <div class="view-item">
                      <h4>Вид угодий</h4>
                      <span>{{ tluText[index] }}</span>
                    </div>
                    <div class="view-item">
                      <h4>Площадь, м<sup>2</sup></h4>
                      <span>{{ item.area }}</span>
                    </div>
                  </div>
                  <h5 class="view-title">Сведения о правообладателях и арендаторах ЗУ</h5>
                  <div class="view-item-r" v-for="(item, index) in newObject.right" :key="'right_' + index">
                    <div class="create-content" v-if="'registration' in newObject.right[index]">
                      <h3 class="unit-title">Право {{ index + 1 }}</h3>
                      <div class="view-item">
                        <h4>Вид права</h4>
                        <span>{{ item.registration.rightTypeText }}</span>
                      </div>
                      <div class="view-item">
                        <h4>Регистрационный номер</h4>
                        <span>{{ item.registration.regNuber }}</span>
                      </div>
                      <div class="view-item">
                        <h4>Дата регистрации</h4>
                        <span>{{ item.registration.regDate }}</span>
                      </div>
                      <div class="view-item">
                        <h4>Доля в праве (числ)</h4>
                        <span>{{ item.registration.shareNumerator }}</span>
                      </div>
                      <div class="view-item">
                        <h4>Доля в праве (знам)</h4>
                        <span>{{ item.registration.shareDenominator }}</span>
                      </div>
                      <template v-if="item.owners.length > 0 && item.owners !== undefined && item.owners !== null">
                        <div class="view-item-wr create-content" v-for="(owner, index) in item.owners" :key="'owner_' + index">
                          <h3 class="unit-title">Правообладатель {{ index + 1 }}</h3>
                          <div v-if="owner.typeOfOwner !== null & owner.typeOfOwner !== undefined" class="view-item">
                            <h4>Тип правообладателя</h4>
                            <span>{{ owner.typeOfOwner.code_sp }}</span>
                          </div>
                          <template v-if="owner.typeOfOwner !== null & owner.typeOfOwner !== undefined">
                            <div class="create-content" v-if="isOrganizationMix(owner.typeOfOwner.code_sp_code)">
                              <div class="view-item">
                                <h4>Название организации</h4>
                                <span>{{ owner.name }}</span>
                              </div>
                              <div class="view-item">
                                <h4>Полное название организации</h4>
                                <span>{{ owner.fullName }}</span>
                              </div>
                              <div class="view-item">
                                <h4>ИНН</h4>
                                <span>{{ owner.oid }}</span>
                              </div>
                              <div class="view-item">
                                <h4>ОГРН</h4>
                                <span>{{ owner.ogrn }}</span>
                              </div>
                              <div class="view-item">
                                <h4>Адрес</h4>
                                <span>{{ owner.location.text }}</span>
                              </div>
                            </div>
                            <div class="create-content" v-else-if="isPersonMix(owner.typeOfOwner.code_sp_code)">
                              <div class="view-item">
                                <h4>Фамилия</h4>
                                <span>{{ owner.lastName }}</span>
                              </div>
                              <div class="view-item">
                                <h4>Имя</h4>
                                <span>{{ owner.firstName }}</span>
                              </div>
                              <div class="view-item">
                                <h4>Отчество</h4>
                                <span>{{ owner.middleName }}</span>
                              </div>
                              <div class="view-item">
                                <h4>ИНН</h4>
                                <span>{{ owner.oid }}</span>
                              </div>
                              <div class="view-item">
                                <h4>Адрес</h4>
                                <span>{{ owner.location.text }}</span>
                              </div>
                            </div>
                            <div class="create-content" v-else>
                              <div class="view-item">
                                <h4>Наименование</h4>
                                <span>{{ owner.name }}</span>
                              </div>
                            </div>
                          </template>
                        </div>
                      </template>
                      <div class="create-content" v-for="(doc, index) in item.documents" :key="'doc_' + index">
                        <h3 class="unit-title">Документ {{ index + 1 }}</h3>
                        <div class="view-item" v-if="doc.name !== null && doc.name !== undefined">
                          <h4>Название документа</h4>
                          <span>{{ doc.name }}</span>
                        </div>
                        <div class="view-item" v-if="doc.documentType !== null && doc.documentType !== undefined">
                          <h4>Тип документа</h4>
                          <span>{{ doc.documentType }}</span>
                        </div>
                        <div class="view-item" v-if="doc.date !== null && doc.date !== undefined">
                          <h4>Дата</h4>
                          <span>{{ doc.date }}</span>
                        </div>
                        <div class="view-item" v-if="doc.notes !== null && doc.notes !== undefined">
                          <h4>Примечание</h4>
                          <span>{{ doc.notes }}</span>
                        </div>
                        <div class="view-item" v-if="doc.number !== null && doc.number !== undefined">
                          <h4>Номер</h4>
                          <span>{{ doc.number }}</span>
                        </div>
                        <div class="view-item" v-if="doc.seria !== null && doc.seria !== undefined">
                          <h4>Серия</h4>
                          <span>{{ doc.seria }}</span>
                        </div>
                      </div>
                      <div class="view-item-wr" v-for="(enc, index) in item.encumbrance" :key="'enc_' + index">
                        <div class="create-content" v-if="enc.encumbrance !== null">
                          <h3 class="unit-title">Обременения {{ index + 1 }}</h3>
                          <div class="view-item">
                            <h4>Тип обременения</h4>
                            <span>{{ enc.encumbrance.encumbranceType }}</span>
                          </div>
                          <div class="view-item">
                            <h4>Описание</h4>
                            <span>{{ enc.encumbrance.name }}</span>
                          </div>
                          <div class="view-item">
                            <h4>Номер</h4>
                            <span>{{ enc.encumbrance.regNumber }}</span>
                          </div>
                          <div class="view-item">
                            <h4>Дата регистрация</h4>
                            <span>{{ enc.encumbrance.regDate }}</span>
                          </div>
                          <div class="view-item">
                            <h4>Дата начала</h4>
                            <span>{{ enc.encumbrance.dateStarted }}</span>
                          </div>
                          <div class="view-item">
                            <h4>Дата окончания</h4>
                            <span>{{ enc.encumbrance.dateStopped }}</span>
                          </div>
                          <template v-if="enc.encumbranceOwner !== null && enc.encumbranceOwner.length > 0">
                            <div class="create-content" v-for="(encOwner, index) in enc.encumbranceOwner" :key="'encOwner_' + index">
                              <h3 class="unit-title">Правообладатель {{ index + 1 }}</h3>
                              <div class="view-item">
                                <h4>Тип правообладателя</h4>
                                <span>{{ encOwner.typeOfOwner.code_sp }}</span>
                              </div>
                              <div class="create-content" v-if="isOrganizationMix(encOwner.typeOfOwner.code_sp_code)">
                                <div class="view-item">
                                  <h4>Название организации</h4>
                                  <span>{{ encOwner.name }}</span>
                                </div>
                                <div class="view-item">
                                  <h4>Полное название организации</h4>
                                  <span>{{ encOwner.fullName }}</span>
                                </div>
                                <div class="view-item">
                                  <h4>ИНН</h4>
                                  <span>{{ encOwner.oid }}</span>
                                </div>
                                <div class="view-item">
                                  <h4>ОГРН</h4>
                                  <span>{{ encOwner.ogrn }}</span>
                                </div>
                                <div class="view-item">
                                  <h4>Адрес</h4>
                                  <span>{{ encOwner.location.text }}</span>
                                </div>
                              </div>
                              <div class="create-content" v-else-if="isPersonMix(encOwner.typeOfOwner.code_sp_code)">
                                <div class="view-item">
                                  <h4>Фамилия</h4>
                                  <span>{{ encOwner.lastName }}</span>
                                </div>
                                <div class="view-item">
                                  <h4>Имя</h4>
                                  <span>{{ encOwner.firstName }}</span>
                                </div>
                                <div class="view-item">
                                  <h4>Отчество</h4>
                                  <span>{{ encOwner.middleName }}</span>
                                </div>
                                <div class="view-item">
                                  <h4>ИНН</h4>
                                  <span>{{ encOwner.oid }}</span>
                                </div>
                                <div class="view-item">
                                  <h4>Адрес</h4>
                                  <span>{{ encOwner.location.text }}</span>
                                </div>
                              </div>
                              <div class="create-content" v-else>
                                <div class="view-item">
                                  <h4>Наименование</h4>
                                  <span>{{ encOwner.name }}</span>
                                </div>
                              </div>
                            </div>
                          </template>
                          <div class="create-content" v-for="(encDoc, index) in enc.documents" :key="'encDoc_' + index">
                            <h3 class="unit-title">Документ {{ index + 1 }}</h3>
                            <div class="view-item" v-if="encDoc.name !== null && encDoc.name !== undefined">
                              <h4>Название документа</h4>
                              <span>{{ encDoc.name }}</span>
                            </div>
                            <div class="view-item" v-if="encDoc.documentType !== null && encDoc.documentType !== undefined">
                              <h4>Тип документа</h4>
                              <span>{{ encDoc.documentType }}</span>
                            </div>
                            <div class="view-item" v-if="encDoc.date !== null && encDoc.date !== undefined">
                              <h4>Дата</h4>
                              <span>{{ encDoc.date }}</span>
                            </div>
                            <div class="view-item" v-if="encDoc.notes !== null && encDoc.notes !== undefined">
                              <h4>Примечание</h4>
                              <span>{{ encDoc.notes }}</span>
                            </div>
                            <div class="view-item" v-if="encDoc.number !== null && encDoc.number !== undefined">
                              <h4>Номер</h4>
                              <span>{{ encDoc.number }}</span>
                            </div>
                            <div class="view-item" v-if="encDoc.seria !== null && encDoc.seria !== undefined">
                              <h4>Серия</h4>
                              <span>{{ encDoc.seria }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </vue-custom-scrollbar>
            </div>
          <!-- </transition> -->
          <div class="popup-footer">
            <button @click="toReturn">Назад</button>
            <button v-if="activeTab !== 'view'" @click="toForward" class="btn accent-btn">Далее</button>
            <button v-if="isValid && activeTab === 'view'" @click="createLand()" :disabled="!isValid" class="btn accent-btn">{{ mode === 'edit' ? 'Редактировать' : 'Создать'}}</button>
            <button v-if="!isValid && activeTab === 'view'" class="btn disabled-btn">{{ mode === 'edit' ? 'Редактировать' : 'Создать'}}</button>
          </div>
        </div>
        <div class="create-tree-wrapper">
          <transition name="popup-opacity">
            <PopupVue v-if="showLandUsePopup || showLandUseMerPopup" @closePopup="closeAllPopups()">
              <template #content>
                <TreeComponent v-if="showLandUsePopup" :initOnMount="true" :multiple="false" :inputData="landUseList" @setSelected="setSelectedLandUse($event)" />
                <TreeComponent v-if="showLandUseMerPopup" :initOnMount="true" :multiple="false" :inputData="landUseMerList" @setSelected="setSelectedLandUseMer($event)" />
              </template>
            </PopupVue>
          </transition>
        </div>
      </div>
    </div>
    <!-- <transition name="popup-opacity">
      <PopupVue @closePopup="setShowPopup({key: 'region', value: false})" v-show="selectOkato">
        <template #content>
          <transition name="popup-scale">
            <LandRegionVue/>
          </transition>
        </template>
      </PopupVue>
    </transition> -->
    <PopupVue v-if="deleteAskDialogShow" @closePopup="closeAllPopups()">
      <template #content>
        <div class="deleteAskDialogShow">
          <h4>Вы уверены, что хотите удалить сведения об участке <span>{{ newObject.regNum }}</span> ?</h4>
          <button @click="deleteObject" class="btn accent-btn delete-button">Удалить</button>
          <button @click="deleteAskDialogShow = false" class="btn accent-btn">Отмена</button>
        </div>
      </template>
    </PopupVue>
  </div>
</template>

<script>
import RightEditVue from '../RightEditVue.vue'
import FileLoader from '../FileLoader.vue'
import PopupVue from '../PopupVue.vue'
import TreeComponent from '../tree/TreeComponent.vue'
import MapCreateEditVue from './MapCreateEditVue'
import LandRegionVue from './LandRegionVue.vue'

import { eventBus } from '@/main.js'
import imageCompression from 'browser-image-compression'
import Inputmask from 'inputmask'
import gql from 'graphql-tag'
import moment from 'moment'
import axios from 'axios'

const CHECK_DUPLICATE_LAND = gql`
query getLands(
  $search: String
  ){
  landList(
    first: 3,
    search: $search
    ){
    edges{
      node{
        pk
        id
        regNum
      }
    }
  }
}
`

const DELETE_LAND = gql`
mutation deleteLand($id: ID) {
  deleteLand(id: $id){
    ok
  }
}
`

export default {
  components: {
    RightEditVue,
    FileLoader,
    LandRegionVue,
    TreeComponent,
    PopupVue,
    MapCreateEditVue
  },
  props: ['mode', 'pk'],
  data () {
    return {
      selectOkato: false,
      parseLoading: false,
      appendixInitData: null,
      photoInitData: null,
      deleteAskDialogShow: false,
      inputTimer: null,
      createLandLoading: false,
      createLandLoadingText: '',
      geometry: null,
      moment: moment,
      activeTab: 'general',
      randomArr: [],
      geomRoundedArea: null,
      areaHectare: '',
      areaHectareGeom: '',
      showLandUsePopup: false,
      showLandUseMerPopup: false,
      photos: [],
      isValid: true,
      currentRegNum: '',
      isMapReady: false,
      settings: {
        suppressScrollX: true
      },
      newObject: {
        regNum: '',
        areaBydoc: null,
        cadCost: null,
        typeZuCode: null,
        note: null,
        landUseCode: null,
        landUseText: null, // не нужно беку(только для вывода пользователю)
        landUseBydoc: null,
        landUseMerCode: null,
        landUseMerText: null, // не нужно беку(только для вывода пользователю)
        categoryCode: null,
        photo: [],
        appendices: [],
        landTlu: [
          {
            tluCode: null,
            area: null
          }
        ],
        sridOriginal: '4326',
        areaBygeom: null,
        right: [ // rightSet
          /* {
            localId: 1, // не нужен беку. Используется для :key чтобы корректно работала перерисовка элементов после их удаления
            propsData: null
          } */
        ],
        location: {
          text: null,
          note: null,
          kolhoz: null
        }
      }
    }
  },
  computed: {
    permisCreate () {
      return this.checkHavePermissionMix('change_', '*')
    },
    typeZuText () {
      let a = this.typeZuListOptions.find(item => {
        return item.code === this.newObject.typeZuCode
      })
      if (a !== undefined) {
        return a.label
      } else return ''
    },
    categoryText () {
      let a = this.categoryListOptions.find(item => {
        return item.code === this.newObject.categoryCode
      })
      if (a !== undefined) {
        return a.label
      } else return ''
    },
    tluText () {
      let arrTlu = []
      this.newObject.landTlu.forEach(itemLandTlu => {
        let b = this.tluListOptions.find(item => {
          return item.code === itemLandTlu.tluCode
        })
        if (b !== undefined) {
          return arrTlu.push(b.label)
        }
      })
      return arrTlu
    },
    typeZuListOptions () {
      return this.createOptions(this.$store.getters.TYPE_ZU_LIST)
    },
    categoryListOptions () {
      return this.createOptions(this.$store.getters.CATEGORY_LIST)
    },
    tluListOptions () {
      return this.createOptions(this.$store.getters.TLU_LIST)
    },
    rightListOptions () {
      return this.$store.getters.value('rightListOptions')
    },
    landUseList () {
      return this.createTreeListMix(this.$store.getters.LAND_USE_LIST)
    },
    landUseMerList () {
      return this.createTreeListMix(this.$store.getters.LAND_USE_MER_LIST)
    },
    editLoading () {
      return this.$store.getters.value('editLoading')
    }
  },
  watch: {
    editLoading (newVal) {
      if (!newVal) { // загрузка закончилась
        this.parseLand(this.$store.getters.value('landEdit'))
      }
    },
    'newObject.regNum' (newVal) {
      if (newVal) {
        if (this.inputTimer !== null) {
          clearTimeout(this.inputTimer)
        }
        this.inputTimer = setTimeout(() => {
          this.$apollo.query({
            query: CHECK_DUPLICATE_LAND,
            variables: {
              search: this.newObject.regNum
            }
          }).then(similarLand => {
            if (similarLand.data.landList.edges.length > 0) {
              if (this.newObject.regNum === similarLand.data.landList.edges[0].node.regNum && this.currentRegNum !== newVal) {
                this.isValid = false
              } else {
                this.isValid = true
              }
            } else {
              this.isValid = true
            }
          })
        }, 0)
      }
    }
  },
  mounted () {
    var im = new Inputmask('99:99:999999[9]:[у][У]9[9][9][9][9][9][9][9][9][9]')
    im.mask(document.querySelector('.reg-number'))
  },
  methods: {
    setNewGeometry (e) {
      this.geometry = e
    },

    deleteObject () {
      this.$apollo.mutate({
        mutation: DELETE_LAND,
        variables: {
          id: this.pk.toString()
        }
      }).then(response => {
        if (response.data.deleteLand.ok) {
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Удаление участка',
            text: 'Участок удален!'
          })
          eventBus.$emit('finishDeleteObject')
        }
      }).catch(e => {
        console.log(e)
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Удаление участка',
          text: 'Не удалось удалить участок!'
        })
      })
      this.deleteAskDialogShow = false
    },
    setRoundedArea (data) {
      this.geomRoundedArea = data.areaBygeom
    },
    parseLand (land) {
      // this.$store.dispatch('SET_VALUE', {key: 'parseLoading', value: true})
      this.parseLoading = true
      this.newObject.regNum = land.regNum
      this.newObject.areaBydoc = land.areaBydoc
      this.newObject.areaBygeom = land.areaBygeom
      this.newObject.cadCost = land.cadCost
      this.newObject.typeZuCode = land.typeZu.code
      this.currentRegNum = land.regNum
      if (land.contourSet !== undefined && land.contourSet !== null && land.contourSet.edges.length > 0) {
        try {
          let geojson = {
            type: 'FeatureCollection',
            features: []
          }
          land.contourSet.edges.forEach(contourEdge => {
            geojson.features.push({
              type: 'Feature',
              properties: {
                reg_num: contourEdge.node.properties.regNum,
                srid_original: this.newObject.sridOriginal
              },
              geometry: contourEdge.node.geometry
            })
          })
          this.geometry = geojson
        } catch (error) {
          console.error('fail parce geometry', error)
        }
      }
      if (land.permittedUse !== null && land.permittedUse !== 'null') {
        if (land.permittedUse.landUse !== null && land.permittedUse.landUse !== 'null') {
          this.newObject.landUseCode = land.permittedUse.landUse.code
          this.newObject.landUseText = land.permittedUse.landUse.text
        }
        if (land.permittedUse.landUseMer !== null && land.permittedUse.landUseMer !== 'null') {
          this.newObject.landUseMerCode = land.permittedUse.landUseMer.code
          this.newObject.landUseMerText = land.permittedUse.landUseMer.text
        }
        this.newObject.landUseBydoc = land.permittedUse.landUseBydoc
      }
      if (land.location !== null && land.location !== 'null') {
        this.newObject.location.text = land.location.text
        this.newObject.location.note = land.location.note
        this.newObject.location.kolhoz = land.location.kolhoz
        // if (land.location.okatoSp !== undefined) {
        //   this.newObject.location.okatoSp.text = land.location.okatoSp.text
        // }
      }
      if (land.category !== null && land.category !== 'null') {
        this.newObject.categoryCode = land.category.code
      }
      try {
        this.newObject.landTlu = land.landTluSet.edges.map(edge => {
          return {
            tluCode: edge.node.tlu.code,
            area: edge.node.area
          }
        })
      } catch (error) {
        console.warn('fail parse tlu')
      }

      let rightArr = []
      this.newObject.right = []
      land.rightSet.edges.forEach(rightEdge => {
        rightArr.push({
          localId: this.getRandom(),
          propsData: rightEdge.node
        })
      })
      // console.log('this.newObject', this.newObject)
      this.newObject.right = rightArr

      if (land.appendixSet !== undefined && land.appendixSet !== null && land.appendixSet.edges.length > 0) {
        this.appendixInitData = []
        land.appendixSet.edges.forEach(appendEdge => {
          this.appendixInitData.push({
            name: appendEdge.node.name,
            file: appendEdge.node.file
          })
        })
      }

      if (land.photoSet !== undefined && land.photoSet !== null && land.photoSet.edges.length > 0) {
        this.photoInitData = []
        land.photoSet.edges.forEach(appendEdge => {
          this.photoInitData.push({
            name: appendEdge.node.name,
            file: appendEdge.node.file
          })
        })
      }
      // this.$store.dispatch('SET_VALUE', {key: 'parseLoading', value: false})
      this.parseLoading = false
    },

    getRandom () {
      return 100 + Math.floor(Math.random() * Math.floor(999999))
    },

    compressImage (imageFile) {
      // var imageFile = event.target.files[0]
      var options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 400,
        useWebWorker: true
      }

      return imageCompression(imageFile, options)
        .then(compressedFile => {
          return compressedFile // write your own logic
        })
        .catch(error => {
          console.log(error.message)
        })
    },

    async createLand () {
      let q = new RegExp(/\d{2}:\d{1,2}:?\d{0,7}:?[уУ]?\d*/)
      this.newObject.areaBygeom = this.geomRoundedArea
      if (!q.test(this.newObject.regNum)) {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Создание объекта',
          text: 'Поле "Кадастровый номер" пустое или заполнено неверно!'
        })
        this.activeTab = 'general'
        return
      }

      if (this.newObject.regNum.indexOf('У') !== -1 || this.newObject.regNum.indexOf('у') !== -1) { // проверка на условный участок

      } else {
        if (this.newObject.areaBydoc === null || String(this.newObject.areaBydoc) === '0' || this.newObject.areaBydoc === '') {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Создание объекта',
            text: 'Поле "Площадь по документам" не может быть пустым или равным 0!'
          })
          this.activeTab = 'general'
          return
        }
      }

      this.createLandLoading = true
      this.createLandLoadingText = 'Создание участка'

      // загрузка фото
      let landPhoto = null // будет подставляться перед отправкой
      if (this.newObject.photo.length > 0) {
        landPhoto = []
        let photoArr = []
        let photoLoadDone = 0
        this.createLandLoadingText = 'Загрузка фото 0 из ' + this.newObject.photo.length
        for (let i = 0; i < this.newObject.photo.length; i++) {
          if (this.newObject.photo[i].uploadByUser === false) { // если файл был загружен ранее(при редактировании), то просто добавляем его без загрузки в minio
            landPhoto.push({
              file: this.newObject.photo[i].file,
              name: this.newObject.photo[i].name
            })
          } else {
            let _file = this.newObject.photo[i]
            let _fileNameWithHash = ''
            photoArr.push(
              this.uploadToMinioMix('photo', _file).then(photoRes => {
                console.log(photoRes)
                photoLoadDone++
                _fileNameWithHash = photoRes
                this.createLandLoadingText = `Загрузка фото ${photoLoadDone} из ${this.newObject.photo.length}`
                // загрузка превью
                this.compressImage(this.newObject.photo[i]).then(_compressFile => {
                  _compressFile.name = 'preview_' + _fileNameWithHash
                  this.uploadToMinioMix('photo', _compressFile, true)
                })
                return Promise.resolve(photoRes) // нужно чтобы в promiseAll были значения, а не массив из undefined
              })
            )
          }
        }
        try {
          let allPhotoUrls = await Promise.all(photoArr)
          allPhotoUrls.forEach((photoUrl, index) => {
            let _photo = {
              name: this.newObject.photo[index].name,
              file: photoUrl
            }
            landPhoto.push(_photo)
          })
        } catch (error) {
          landPhoto = null
          console.warn('fail upload photo', error)
        }
        this.createLandLoadingText = 'Создание участка'
      }

      // загрузка аппендикса
      let landAppendices = null // будет подставляться перед отправкой
      if (this.newObject.appendices.length > 0) {
        landAppendices = []
        let appendixArr = []
        let appendixDone = 0
        this.createLandLoadingText = 'Загрузка приложений 0 из ' + this.newObject.appendices.length
        for (let i = 0; i < this.newObject.appendices.length; i++) {
          let _file = this.newObject.appendices[i]
          if (_file.uploadByUser === false) { // если файл был загружен ранее(при редактировании), то просто добавляем его без загрузки в minio
            landAppendices.push({
              name: _file.name,
              file: _file.file
            })
          } else {
            appendixArr.push(
              this.uploadToMinioMix('appendix', _file).then(appendixRes => {
                appendixDone++
                this.createLandLoadingText = `Загрузка приложений ${appendixDone} из ${this.newObject.appendices.length}`
                return Promise.resolve(appendixRes) // нужно чтобы в promiseAll были значения, а не массив из undefined
              })
            )
          }
        }
        try {
          let allAppendixUrls = await Promise.all(appendixArr)
          allAppendixUrls.forEach((appendUrl, index) => {
            let _appendix = {
              name: this.newObject.appendices[index].name,
              file: appendUrl
            }
            landAppendices.push(_appendix)
          })
        } catch (error) {
          landAppendices = null
          console.warn('fail upload appendices', error)
        }
      }

      // загрузка документов права
      let landRightsDocs = null // будет подставляться перед отправкой. Будет подставляться в конце
      if (this.newObject.right !== null && this.newObject.right.length > 0) {
        this.createLandLoadingText = 'Загрузка документов'
        landRightsDocs = []
        let _rightIndex = 0
        for (let _right of this.newObject.right) { // проход по кажому праву
          landRightsDocs.push([])
          if (_right.documents !== undefined && _right.documents !== null && _right.documents.length > 0) {
            let currentRightDocUrls = [] // ссылки на документы конкретного права
            _right.documents.forEach(_rightDoc => {
              if (_rightDoc.uploadByUser === false) { // если файл был загружен ранее(при редактировании), то просто добавляем его без загрузки в minio
                currentRightDocUrls.push(_rightDoc.file)
              } else { // иначе добавляем в маасив промисов для загрузки на минио
                currentRightDocUrls.push(
                  this.uploadToMinioMix('document', _rightDoc.doc)
                )
              }
            })
            try {
              currentRightDocUrls = await Promise.all(currentRightDocUrls)
              landRightsDocs[_rightIndex] = currentRightDocUrls
              _right.documents.forEach((_rightDoc, _docIndex) => {
                console.log(_rightDoc)
                landRightsDocs[_rightIndex][_docIndex] = { // заполняю в соответсвии с ожидаемым форматом бека
                  document_type: _rightDoc.documentType,
                  notes: _rightDoc.notes,
                  date: _rightDoc.date,
                  seria: _rightDoc.seria,
                  number: _rightDoc.number,
                  document_type_code: _rightDoc.documentTypeCode,
                  file: currentRightDocUrls[_docIndex]
                }
              })
            } catch (error) {
              landRightsDocs[_rightIndex] = null
            }
          }
          _rightIndex++
        }
        this.createLandLoadingText = 'Создание участка'
      }

      // загрузка документов обременений
      let landEncumbranceDoc = [] // повторяет структуру прав
      if (this.newObject.right !== null && this.newObject.right.length > 0) {
        let _rightIndex = 0
        for (let _right of this.newObject.right) {
          landEncumbranceDoc.push([]) // добавляем право
          if (_right !== null && _right.encumbrance !== undefined && _right.encumbrance !== null && _right.encumbrance.length > 0) {
            let _encumbranceIndex = 0
            for (let _encumbrance of _right.encumbrance) {
              landEncumbranceDoc[_rightIndex].push([]) // добавляем обременение в право
              if (_encumbrance.documents !== undefined && _encumbrance.documents !== null && _encumbrance.documents.length > 0) {
                let promises = []
                // console.log('Первые данные', _encumbrance.documents)
                _encumbrance.documents.forEach(async (_encumbranceDoc) => {
                  if (_encumbranceDoc.uploadByUser === false) { // проверяем не был ли загружен документ ранее
                    promises.push(_encumbranceDoc.file)
                  } else {
                    promises.push(this.uploadToMinioMix('document', _encumbranceDoc.doc))
                  }
                })
                try {
                  let currentEncumbranceDocsUrls = await Promise.all(promises)
                  // console.log('Свои данные', _encumbrance.documents)
                  // debugger
                  _encumbrance.documents.forEach((encDoc, encDocIndex) => {
                    landEncumbranceDoc[_rightIndex][_encumbranceIndex][encDocIndex] = {
                      document_type: encDoc.documentType,
                      document_type_code: encDoc.documentTypeCode,
                      file: currentEncumbranceDocsUrls[encDocIndex],
                      date: encDoc.date,
                      seria: encDoc.seria,
                      notes: encDoc.notes,
                      number: encDoc.number
                    }
                    // console.log(landEncumbranceDoc[_rightIndex][_encumbranceIndex][encDocIndex])
                  })
                } catch (error) {
                  landEncumbranceDoc[_rightIndex] = []
                }
              }
              _encumbranceIndex++
            }
          }
          _rightIndex++
        }
      }

      let snakeObj = this.camelCaseKeysToUnderscore(JSON.parse(JSON.stringify(this.newObject))) // делаю копию объекта чтобы не терять что ввел пользователь и преобразую все из camelCase в snake_case
      snakeObj.area_bygeom = parseFloat(snakeObj.area_bygeom) // area_bygeom ожидается как Float

      if (snakeObj.land_tlu.length > 0) { // если есть угодья
        snakeObj.land_tlu.forEach((tlu, index) => {
          if (tlu.tlu_code === null) {
            snakeObj.land_tlu.splice(index, 1)
          }
        })
        if (snakeObj.land_tlu.length === 0) {
          delete snakeObj.land_tlu
        }
      }
      if (landPhoto !== null) { // если есть фото
        snakeObj.photo = landPhoto
      }
      if (landRightsDocs !== null && landRightsDocs.length > 0) { // заменяем документы в праве
        for (let i = 0; i < snakeObj.right.length; i++) {
          if (snakeObj.right[i].documents !== null && snakeObj.right[i].documents !== undefined && snakeObj.right[i].documents.length > 0) {
            for (let rightDocIndex = 0; rightDocIndex < snakeObj.right[i].documents.length; rightDocIndex++) {
              snakeObj.right[i].documents[rightDocIndex] = landRightsDocs[i][rightDocIndex]
            }
          }
        }
      }

      if (landEncumbranceDoc !== null && landEncumbranceDoc.length > 0) { // заменяем документы у обременений прав
        for (let _rightIndex = 0; _rightIndex < snakeObj.right.length; _rightIndex++) {
          if (snakeObj.right[_rightIndex].encumbrance !== undefined && snakeObj.right[_rightIndex].encumbrance !== null && snakeObj.right[_rightIndex].encumbrance.length > 0) {
            for (let _encumbranceIndex = 0; _encumbranceIndex < snakeObj.right[_rightIndex].encumbrance.length; _encumbranceIndex++) {
              let currentEnc = snakeObj.right[_rightIndex].encumbrance[_encumbranceIndex]
              if (currentEnc.documents !== undefined && currentEnc.documents !== null && currentEnc.documents !== undefined && currentEnc.documents.length > 0) {
                for (let encDocIndex = 0; encDocIndex < currentEnc.documents.length; encDocIndex++) {
                  currentEnc.documents[encDocIndex] = landEncumbranceDoc[_rightIndex][_encumbranceIndex][encDocIndex]
                }
              }
            }
          }
        }
      }

      if (landAppendices !== null && landAppendices.length > 0) {
        snakeObj.appendices = landAppendices
      }

      if (this.mode === 'edit') {
        snakeObj.id = this.pk
      }

      let obj = {
        fields: ['all'],
        data: {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              properties: snakeObj,
              geometry: null
            }
          ]
        }
      }

      if (this.geometry !== null && this.geometry.features.length > 0) { // если геометрия есть, то заполняем остальные фичи
        for (let i = 0; i < this.geometry.features.length; i++) {
          let _feature = this.geometry.features[i]
          let _regNum = (_feature.properties !== null && _feature.properties.reg_num !== undefined) ? _feature.properties.reg_num : this.newObject.regNum
          _feature.properties.reg_num = _regNum // устанавливаем актуальный кадастровый номер.(если создание, то тот, который был указан, если редактрование, то тот, который спарсился)
          _feature.properties.srid_original = this.newObject.sridOriginal // устанавливаем актуальный кадастровый номер.(если создание, то тот, который был указан, если редактрование, то тот, который спарсился)
          delete _feature.id
          if (i === 0) { // в превой изменяем только геомтрию
            obj.data.features[0].geometry = _feature.geometry
          } else {
            obj.data.features.push(_feature)
          }
        }
      }

      /* if (this.mode !== 'edit') {
        delete obj.fields
      } */

      obj.data.features[0].properties.right.forEach(right => {
        right.owners.forEach(owner => {
          if (owner.type_of_owner !== undefined && owner.type_of_owner !== null) {
            owner.code_sp_code = owner.type_of_owner.code_sp_code
            owner.code_sp = owner.type_of_owner.code_sp
          }
        })
      })
      // console.log(obj.data.features[0].properties)

      obj.data.features[0].properties.right.forEach(right => {
        right.encumbrance.forEach(enc => {
          if (enc.encumbrance_owner !== null && enc.encumbrance_owner !== undefined && enc.encumbrance_owner.length > 0) {
            enc.encumbrance_owner.forEach(owner => {
              // console.log(owner)
              if (owner.type_of_owner !== undefined && owner.type_of_owner !== null) {
                owner.code_sp_code = owner.type_of_owner.code_sp_code
                owner.code_sp = owner.type_of_owner.code_sp
              }
            })
          }
        })
      })
      // console.log(obj.data.features[0].properties)

      if (obj.data.features[0].properties.right.length > 0) { // удаление не нужных беку данных из права
        for (let i = 0; i < obj.data.features[0].properties.right.length; i++) {
          delete obj.data.features[0].properties.right[i].props_data
          delete obj.data.features[0].properties.right[i].local_id
          let enc = obj.data.features[0].properties.right[i].encumbrance
          if (enc !== null && enc !== undefined && enc.length > 0) {
            for (let j = 0; j < enc.length; j++) {
              delete enc[j].propsData
            }
          }
        }
      }

      if (obj.data.features[0].properties.right.length === 0 || Object.keys(obj.data.features[0].properties.right[0]).length === 0) {
        obj.data.features[0].properties.right.splice(0, 1)
      }

      for (let key in obj.data.features[0].properties) {
        if (!Array.isArray(obj.data.features[0].properties[key])) { // если не массив
          if (obj.data.features[0].properties[key] === null) {
            delete obj.data.features[0].properties[key]
          }
        } else { // если массив
          if (obj.data.features[0].properties[key].length === 0) {
            delete obj.data.features[0].properties[key]
          }
        }
      }

      // let url = 'http://192.168.2.250:8000' + '/api/v1/land/create/'
      let url = this.$store.getters.value('host') + '/ugeoapi/api/v1/land/create/'
      axios.post(url, obj).then(response => {
        // console.log(response)
        if (this.mode === 'edit') {
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Редактирование объекта',
            text: 'Объект успешно изменен!'
          })
        } else {
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Создание объекта',
            text: 'Объект успешно создан!'
          })
        }
        this.createLandLoading = false
        eventBus.$emit('finishCeateEdit', response.data.pk)
        // console.log(response)
      }).catch(err => {
        // console.log(err.response)
        if (this.mode === 'edit') {
          if (err.response.status === 403) {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Редактирование объекта',
              text: 'У вас недостаточно прав для редактирования объекта!'
            })
          } else {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Редактирование объекта',
              text: 'Ошибка при редактировании объекта!'
            })
          }
        } else {
          if (err.response.status === 403) {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Редактирование объекта',
              text: 'У вас недостаточно прав для редактирования объекта!'
            })
          } else {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Создание объекта',
              text: 'Ошибка при создании объекта!'
            })
          }
        }
        this.createLandLoading = false
        console.log('fail to create land. Cause:', err)
      })
    },

    setappendices (e) {
      this.newObject.appendices = e
    },

    setSelectedLandUseMer (e) {
      this.newObject.landUseMerCode = e.fullInfo[0].id
      this.newObject.landUseMerText = e.fullInfo[0].text
      this.closeAllPopups()
    },

    setSelectedLandUse (e) {
      this.newObject.landUseCode = e.fullInfo[0].id
      this.newObject.landUseText = e.fullInfo[0].text
      this.closeAllPopups()
    },

    setShowPopup (name, value) {
      if (name === 'landUseCode') {
        this.showLandUsePopup = value
      }
      if (name === 'landUseMerCode') {
        this.showLandUseMerPopup = value
      }
      if (name === 'selectOkato') {
        this.selectOkato = value
      }
    },

    closeAllPopups () {
      this.showLandUsePopup = false
      this.showLandUseMerPopup = false
      this.deleteAskDialogShow = false
    },

    changeRight (e, i) {
      e.propsData = this.newObject.right[i].propsData
      e.localId = this.newObject.right[i].localId
      this.$set(this.newObject.right, i, e)
    },

    setPhoto (e) {
      this.newObject.photo = e
    },

    delItem (index, type) {
      switch (type) {
        case 'tlu':
          this.newObject.landTlu.splice(index, 1)
          break

        case 'owner':
          this.newObject.owners.splice(index, 1)
          break

        case 'right':
          this.newObject.right.splice(index, 1)
          break

        default:
          break
      }
    },

    addItem (type) {
      switch (type) {
        case 'tlu':
          this.newObject.landTlu.push({
            code: null,
            area: null
          })
          break

        case 'owner':
          this.newObject.owners.push({
            typeOfOwner: null,
            oid: null
          })
          break

        case 'right':
          this.newObject.right.push({
            localId: this.getRandom()
          })
          break

        default:
          break
      }
    },

    createOptions (data) {
      if (data === null) {
        return null
      }
      let options = data.edges.map(item => {
        return {
          code: item.node.code,
          label: item.node.text
        }
      })
      return options
    },

    inputAreaMeter (e, type) {
      if (type === 'bydoc') {
        this.areaHectare = this.convetMetersToHectareMix(this.newObject.areaBydoc)
      } else {
        this.areaHectareGeom = this.convetMetersToHectareMix(this.newObject.areaBygeom)
      }
    },
    inputAreaHectare (e, type) {
      if (type === 'bydoc') {
        this.newObject.areaBydoc = this.convetHectareToMetersMix(this.areaHectare)
      } else {
        this.newObject.areaBygeom = this.convetHectareToMetersMix(this.areaHectareGeom)
      }
    },
    cancelCreate () {
      this.$emit('cancelCreate')
    },
    formatter (date) {
      return moment(date).format('D.MM.yyyy')
    },
    toReturn () {
      if (this.activeTab === 'general') {
        this.$emit('cancelCreate')
      } else if (this.activeTab === 'characteristic') {
        this.activeTab = 'general'
      } else if (this.activeTab === 'owner') {
        this.activeTab = 'characteristic'
      } else if (this.activeTab === 'map') {
        this.activeTab = 'owner'
      } else if (this.activeTab === 'view') {
        this.activeTab = 'map'
      }
    },
    toForward () {
      if (this.activeTab === 'general') {
        this.activeTab = 'characteristic'
      } else if (this.activeTab === 'characteristic') {
        this.activeTab = 'owner'
      } else if (this.activeTab === 'owner') {
        this.activeTab = 'map'
      } else if (this.activeTab === 'map') {
        this.activeTab = 'view'
      }
    },
    qwe () {
      console.log(this.newObject)
    }
  }
}
</script>

<style lang="scss">
.pos-r {
  display: flex;
  align-items: flex-start;
  .right-edit {
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 15px;
    flex-basis: 100%;
  }
  .right-header {
    padding-right: 40px;
    margin-bottom: 12px;
  }
  .cell.no-border {
    margin-left: -20px;
  }
}

.popup-create-wrapper {
  display: flex;
  width: 1150px;
  height: 90vh;
  @media screen and (max-width: 1199px) {
    width: 75vw;
  }
}

.popup-menu {
  flex: none;
  padding-top: 30px;
  padding-bottom: 35px;
  max-width: 310px;
  width: 100%;
  border-right: 1px solid #e6e6e6;
  ul {
    position: relative;
    margin: 0;
    padding-left: 0;
    height: 100%;
    list-style: none;
    li {
      position: relative;
      cursor: pointer;
      padding: 17px 30px;
      font-size: 14px;
      border-right: 4px solid transparent;
      transition: .3s;
      &:hover {
        background-color: #eeeefd;
        color: #4E53E7;
      }
      &.active {
        background-color: #eeeefd;
        border-color: #4E53E7;
        color: #4E53E7;
      }
      &.no-valid {
        border-color: #ff6161;
      }
    }
    .delete {
      background-color: rgba(255, 189, 189, 0.2);
      position: absolute;
      bottom: 0;
      width: 100%;
      color: rgba(221, 101, 101, 1);
      &:hover {
        background-color: rgba(250, 150, 150, 0.4);
        color: rgb(255, 97, 97);
      }
    }
  }
  @media screen and (max-width: 991px) {
    width: 205px;
  }
}

.popup-create {
  position: relative;
  width: 100%;
  padding-top: 30px;
  padding-bottom: 35px;
  padding-left: 55px;
}

.create-content {
  p {
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 10px;
    span {
      color: #FF3D00;
    }
  }
  .input-wrap {
    margin-bottom: 15px;
  }
  .area {
    display: flex;
    justify-content: space-between;
    .half {
      position: relative;
      &:first-child {
        margin-right: 10px;
      }
      span {
        position: absolute;
        font-size: 13px;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        color: #545454;
      }
    }
  }
}

.step {
  height: calc(100% - 100px);
  .scroll-info {
    height: calc(100% - 40px);
    .create-content {
      padding-right: 15px;
    }
  }
  .right-content {
    height: calc(100% - 40px);
    max-width: 400px;
    padding-right: 15px;
    overflow: auto;
    scrollbar-width: thin;
    .right-wrap {
      padding-bottom: 15px;
      margin-bottom: 30px;
    }
    .encumbrance {
      width: 450px;
      padding-right: 15px;
      @media screen and (max-width: 1199px) {
        width: 460px;
        left: 0;
        box-shadow: none;
        background-color: #fff;
        z-index: 2;
      }
    }
    .scroll-encumbrance {
      height: calc(100% - 185px);
    }
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #cccccc;
      border-radius: 3px;
    }
  }
}

.step-1 {
  .input-wrap {
    max-width: 430px;
    input.form-control {
      padding-right: 30px;
      font-size: 13px;
      width: 100%;
      height: 40px;
    }
    textarea {
      padding-top: 10px;
      font-size: 13px;
      width: 100%;
      height: 80px;
    }
  }
}

.step-2 {
  .btn-add {
    max-width: 430px;
  }
}

.step-2,
.step-3 {
  .input-wrap {
    max-width: 430px;
  }
  .btn-add {
    display: block;
    margin-top: 20px;
    width: 100%;
    text-align: center;
    color: #4e53e7;
    border: none;
    span {
      display: inline-block;
      vertical-align: bottom;
      font-size: 24px;
    }
  }
}

.step-4 {
  width: 760px;
  .create-content {
    width: 100%;
    height: calc(100% - 50px);
  }
}

.step-5 {
  .create-content {
    display: table;
    width: 580px;
    table-layout: fixed;
  }
  .view-item {
    display: table-row;
    font-size: 12px;
    h4,
    span {
      display: table-cell;
      padding: 10px 0;
      border-bottom: 1px solid #e6e6e6;
    }
    h4 {
      min-width: 160px;
      padding-right: 30px;
    }
  }
}

.view-title {
  font-size: 16px;
  margin: 20px 0 10px;
}

.unit-title {
  margin-top: 15px;
  margin-bottom: 10px;
  font-size: 15px;
}

.type-land,
.type-law,
.type-owner {
  display: table;
  table-layout: fixed;
  width: 100%;
  .type-row {
    display: table-row;
    height: 30px;
    max-height: 30px;
    &:first-child {
      .cell {
        border: 1px solid #e6e6e6;
        padding-left: 10px;
        font-size: 12px;
        span {
          display: inline-block;
          vertical-align: sub;
        }
      }
    }
    .cell.no-border {
      border: none;
      text-align: center;
      button {
        display: inline-block;
        text-align: center;
      }
    }
    input[type=text],
    input[type=number],
    input[type=date] {
      font-size: 12px;
      border-radius: 0;
      height: 29px;
      width: 100%;
      border: 1px solid #e6e6e6;
      border-top: 0;
      padding-left: 15px;
      transition: .3s;
      &:focus {
        border: 1px solid #bfc1e6;
      }
    }
    .table-select .vs__search {
      margin: 0;
      padding-left: 11px;
      border: none;
    }
  }
  .cell {
    position: relative;
    display: table-cell;
    vertical-align: middle;
    font-size: 12px;
    width: 165px;
  }
  .cell-select-border {
    border-right: 1px solid #e6e6e6;
  }
}

.table-select {
  position: absolute;
  width: 100%;
  top: 0;
}

.table-select .vs__actions {
  margin-right: 8px;
  background-position: 50% 7px;
}

.table-select .vs__dropdown-toggle {
  padding-bottom: 0;
  font-size: 12px;
  border-radius: 0;
  min-height: 23px;
  border-top: 0;
  border-right: 0;
}

.table-select .vs__dropdown-option {
  font-size: 12px;
  max-width: none;
  display: block;
}

.table-select .vs__selected {
  display: inline-block;
  margin: 0;
  margin-top: 5px;
  padding: 0;
  padding-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 5px;
}

.table-select .vs__selected-options {
  // width: 100%;
  width: calc(100% - 18px);
  height: 28px;
}

.encumbrance-detail-edit-wrap {
  .encumbrance {
    left: 460px;
    right: auto;
  }
}
.create-tree-wrapper {
  z-index: 9;
  .popup-dialog {
    padding: 30px;
  }
}
.right-edit {
  .popup-dialog {
    padding: 30px;
  }
}
.loading-enc-edit {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 150px;
  height: 150px;
  .loader {
    margin-top: 50px;
  }
}
.loading-text {
  position: absolute;
  bottom: 10px;
  left : 10px;
}
.deleteAskDialogShow {
  position: absolute;
  background-color: white;
  border-radius: 8px;
  width: 340px;
  height: 180px;
  top: 50%;
  left: 50%;
  margin-top: -90px;
  margin-left: -170px;
  z-index: 9;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.08);
  padding: 20px;
  text-align: center;
  line-height: 1.5;
  button {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
  button:first-of-type{
    left: 20px;
    background-color: rgb(255, 97, 97);
  }
  span {
    font-size: 18px;
  }
}

.minimap-loader {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PopupCreateVue.vue